import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  InvoiceCustMode,
  InvoiceGroupMode,
} from '../../features/ng-invoice/ng-invoice.interfaces';

export interface InvoiceParams {
  from: string;
  to: string;
  subTotal?: boolean;
  sum?: string;
  custMode?: InvoiceCustMode;
  per?: string;
  type?: InvoiceGroupMode;
}

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get<T = unknown>(params: InvoiceParams): Observable<T[]> {
    let httpParams = new HttpParams();

    if (params.subTotal) httpParams = httpParams.set('subTotal', String(params.subTotal));
    if (params.sum) httpParams = httpParams.set('sum', String(params.sum));
    if (params.custMode) httpParams = httpParams.set('custMode', JSON.stringify(params.custMode));
    if (params.per) httpParams = httpParams.set('per', String(params.per));
    if (params.type) httpParams = httpParams.set('type', String(params.type));

    return this.http.get<any[]>(`/api/invoice/${params.from}/${params.to}`, { params: httpParams });
  }
}
